"use strict";

define('view/report/visualsearch.report',['require','exports','module','underscore','marionette','backbone','uikit/mixins/component.mixin','uikit/channel','../../templates','uikit/elements/label','uikit/modules/input.date','uikit/elements/text','uikit/extra/key.codes'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var Backbone = require('backbone');
  var ComponentMixin = require('uikit/mixins/component.mixin');
  var channel = require('uikit/channel');
  var Templates = require('../../templates');
  var Label = require('uikit/elements/label');
  var DatePicker = require('uikit/modules/input.date');
  var Text = require('uikit/elements/text');
  var CODES = require('uikit/extra/key.codes');
  var VisualSearchToken = Backbone.Model.extend({
    defaults: {
      text: 'text',
      value: ''
    }
  });
  var clearSelection = function clearSelection() {
    var selection = window.getSelection();
    if (selection.rangeCount > 0) {
      selection.getRangeAt(0).startContainer.parentNode.blur();
    }
    selection.removeAllRanges();
  };
  var getCursorPosition = function getCursorPosition() {
    var selection = document.getSelection(),
      caretRange = {};
    if (selection.rangeCount > 0) {
      caretRange = selection.getRangeAt(0);
    }
    return {
      caretStart: caretRange.startOffset,
      caretEnd: caretRange.endOffset,
      selectionLength: caretRange.endOffset - caretRange.startOffset
    };
  };
  var setCursorAt = function setCursorAt(el, position) {
    var range = document.createRange(),
      sel = null;
    el.focus();
    if (!el.childNodes.length) {
      var textNode = document.createTextNode('');
      el.appendChild(textNode);
    }
    sel = window.getSelection();
    range.setStart(el.childNodes[0], position);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  };
  var VisualSearchTokenView = Label.extend({
    template: Templates.IRB['visual.search.token.report.filter'],
    options: _.extend({}, Label.prototype.options, {
      editing: false,
      selected: false,
      icon: 'remove circle',
      dateType: 'false',
      fromDate: null,
      toDate: null
    }),
    update: _.extend({}, Label.prototype.update, {
      selected: false,
      editing: false
    }),
    bindings: {
      text: 'text',
      detail: 'value',
      dateType: 'dateType'
    },
    ui: {
      detail: '.detail',
      dateType: '.dateType'
    },
    events: {
      'keydown': 'handleKeydown',
      'keyup .detail': 'handleKeyupOnDetail',
      'keyup .dateType': 'handleKeyupOnDateType',
      'keydown .detail': 'handleKeydownOnDetail',
      'keydown .dateType': 'handleKeydownOnDateType'
    },
    triggers: {
      'blur': 'deselect',
      'blur .detail': 'not:editing deselect',
      'focus': 'selected',
      'focus .detail': 'editing',
      'click .icon.remove.circle': 'close'
    },
    isDateType: function isDateType() {
      return this.model.get('dateType');
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      if (this.model.get('dateType')) {
        var dateFromOptions = {
          name: 'fromDate',
          model: this.model,
          todayButton: false,
          bindings: {
            value: 'fromDate'
          }
        };
        var dateToOptions = {
          name: 'toDate',
          model: this.model,
          todayButton: false,
          bindings: {
            value: 'toDate'
          }
        };
        var dateFromPicker = new TokenDatePicker(dateFromOptions);
        var dateToPicker = new TokenDatePicker(dateToOptions);
        this.searchTokenForm.addGroup().addField({
          text: "From: "
        }, dateFromPicker).getOption('parent').addField({
          text: "To: "
        }, dateToPicker);
        this.listenTo(this.model, 'change', function () {
          this.triggerMethod('complete');
        });
      }
    },
    setCursorToStart: function setCursorToStart() {
      var el;
      if (this.isDateType()) {} else {
        el = this.ui.detail.get(0);
        setCursorAt(el, 0);
      }
    },
    setCursorToEnd: function setCursorToEnd() {
      var el = this.ui.detail.get(0);
      setCursorAt(el, el.textContent.length);
    },
    setTextContent: function setTextContent(text) {
      if (this.isDateType()) {} else {
        this.ui.detail.text(text);
      }
      this.setCursorToEnd();
    },
    setFocus: function setFocus() {
      this.$el.focus();
      return this;
    },
    setFocusOnEdit: function setFocusOnEdit() {
      if (this.isDateType()) {} else {
        this.ui.detail.focus();
      }
    },
    handleKeydown: function handleKeydown(ev) {
      if (this.el === ev.target) {
        if (ev.keyCode === CODES.BACKSPACE_KEY || ev.keyCode === CODES.DELETE_KEY) {
          ev.preventDefault();
          this.triggerMethod('close');
        }
      }
    },
    handleKeydownOnDetail: function handleKeydownOnDetail(ev) {
      var self = this,
        keyCode = ev.keyCode,
        sel = document.getSelection(),
        caretRange = sel.getRangeAt(0),
        caretStart = caretRange.startOffset,
        caretEnd = caretRange.endOffset,
        selLength = caretEnd - caretStart,
        oldValue = ev.target.textContent;
      if (selLength) {
        ev.stopPropagation();
      }
      if (keyCode === CODES.TAB_KEY || keyCode === CODES.RIGHTARROW_KEY && caretStart !== this.detail.length || keyCode === CODES.LEFTARROW_KEY && caretStart !== 0) {
        ev.stopPropagation();
      } else if (keyCode === CODES.ENTER_KEY || keyCode === CODES.DOWNARROW_KEY || keyCode === CODES.UPARROW_KEY) {
        ev.preventDefault();
      } else if (keyCode === CODES.BACKSPACE_KEY && caretStart === 0 && !selLength) {
        ev.preventDefault();
        clearSelection();
        this.setFocus();
      } else if (keyCode === CODES.ESCAPE_KEY) {
        ev.preventDefault();
        this.ui.detail.blur();
        this.triggerMethod('close');
      } else {
        _.defer(function () {
          if (oldValue !== ev.target.textContent) {
            self._internal.detail = ev.target.textContent;
            self.triggerMethod('value:edit', ev.target.textContent);
          }
        });
      }
    },
    handleKeyupOnDetail: function handleKeyupOnDetail(ev) {
      if (ev.keyCode === CODES.ENTER_KEY) {
        this._internal.detail = ev.target.textContent;
        this.triggerMethod('complete');
      }
    },
    handleKeydownOnDateType: function handleKeydownOnDateType(ev) {
      ev.stopPropagation();
    },
    handleKeyupOnDateType: function handleKeyupOnDateType(ev) {
      ev.stopPropagation();
      if (ev.keyCode === CODES.ENTER_KEY) {
        this.triggerMethod('complete');
      }
    },
    onRender: function onRender() {
      if (this.isDateType()) {} else {
        this.ui.detail.attr('contentEditable', 'true');
      }
    },
    serializeData: function serializeData() {
      var d = Label.prototype.serializeData.apply(this, arguments);
      d.text += ': ';
      return d;
    },
    updateAttributes: function updateAttributes() {
      Label.prototype.updateAttributes.apply(this, arguments);
      this.addClass('selected', this.getBoolOption('selected'));
      this.addClass('editing', this.getBoolOption('editing'));
      this.$el.attr('tabindex', -1);
    }
  });
  var TokenDatePicker = DatePicker.extend({
    onChangeInputValue: function onChangeInputValue() {
      this.updateCalendar();
    }
  });
  var VisualSearchResultItemView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'result',
    tagName: 'a',
    options: {
      text: '',
      selected: false
    },
    update: {
      selected: false
    },
    triggers: {
      'mousedown': 'selected'
    },
    template: Templates.UIKit['visual.search.result'],
    updateAttributes: function updateAttributes() {
      this.addClass('active', this.getBoolOption('selected'));
    }
  });
  var VisualSearchResultFooterView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'result footer',
    tagName: 'span',
    options: {
      count: '',
      text: ''
    },
    triggers: {
      'mousedown': 'press'
    },
    template: Templates.UIKit['visual.search.result.footer']
  });
  var VisualSearchResultsView = Mn.CollectionView.extend(ComponentMixin).extend({
    className: 'results',
    tagName: 'div',
    childView: VisualSearchResultItemView,
    childViewOptions: function childViewOptions() {
      return {
        bindings: _.clone(this.childBindings)
      };
    },
    options: {
      collection: null,
      empty: true
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.addEmptyResultsMessage();
      this.addAnnouncer();
      this.updateEmptyProperty();
    },
    addEmptyResultsMessage: function addEmptyResultsMessage() {
      var emptyResultsMessage = new Text({
        className: 'text result active empty-result',
        text: 'No matches found'
      });
      this.emptyResultsMessage = emptyResultsMessage;
      emptyResultsMessage.render();
      emptyResultsMessage.$el.appendTo(this.$el);
    },
    addAnnouncer: function addAnnouncer() {
      var announcer = new Text({
        attributes: {
          tabindex: '0',
          role: 'alert',
          'aria-live': 'assertive'
        },
        className: 'accessibility-text text announcer',
        text: '',
        visible: false
      });
      this.announcer = announcer;
      announcer.render();
      announcer.$el.appendTo(this.$el);
    },
    showFooter: function showFooter(options) {
      if (_.isEmpty(this.children)) {
        return;
      }
      var footer = new VisualSearchResultFooterView(options),
        self = this;
      this.hideFooter();
      this.footer = footer;
      footer.render();
      footer.$el.appendTo(this.$el);
      footer.on('press', function () {
        self.triggerMethod('press:footer');
      });
    },
    hideFooter: function hideFooter() {
      if (this.footer) {
        this.footer.remove();
      }
    },
    getSelectedResult: function getSelectedResult() {
      return this.selected && this.selected.text;
    },
    onChildviewSelected: function onChildviewSelected(v) {
      this.selectResult(v._index);
      this.triggerMethod('result:selected', v);
    },
    selectResult: function selectResult(index, ignoreSet) {
      var v = null;
      if (this.collection && this.collection.models[index]) {
        v = this.children.findByModel(this.collection.models[index]);
      }
      this.children.without(v).forEach(function (c) {
        c.selected = false;
      });
      if (v) {
        v.selected = true;
        this.scrollResultIntoView(v);
      }
      this.selected = v;
      if (!ignoreSet) {
        this.triggerMethod('result:text', v);
      }
    },
    scrollResultIntoView: function scrollResultIntoView(result) {
      var itemHeight = result.$el.outerHeight(),
        itemPosTop = result.$el.position().top,
        itemPosBottom = itemPosTop + itemHeight,
        listHeight = this.$el.height(),
        listScrollTop = this.$el.scrollTop();
      if (itemPosBottom > listHeight) {
        var scrollMore = itemHeight - (listHeight - itemPosTop);
        this.$el.scrollTop(listScrollTop + scrollMore);
      } else if (itemPosTop < 0) {
        this.$el.scrollTop(listScrollTop + itemPosTop);
      }
    },
    selectNextResult: function selectNextResult() {
      var selected = this.selected,
        index = 0;
      if (selected) {
        index = this.collection.indexOf(selected.model) + 1;
      }
      if (index < this.children.length) {
        this.selectResult(index);
      }
    },
    selectPreviousResult: function selectPreviousResult() {
      var selected = this.selected,
        index = null;
      if (selected) {
        index = this.collection.indexOf(selected.model) - 1;
      }
      this.selectResult(index);
    },
    selectFirstResult: function selectFirstResult() {
      this.selected = null;
      if (!_.isEmpty(this.collection)) {
        this.selectResult(0, true);
      }
    },
    onBeforeRender: function onBeforeRender() {
      this.triggerMethod('results:added');
    },
    onAddChild: function onAddChild() {
      this.triggerMethod('results:added');
      this.selectFirstResult();
      this.hideFooter();
    },
    onRemoveChild: function onRemoveChild(v) {
      v.selected = false;
      this.selectFirstResult();
      this.hideFooter();
    },
    onRenderCollection: function onRenderCollection() {
      this.selectResult(0, true);
      this.hideFooter();
    },
    onChangeCollection: function onChangeCollection() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove reset update', _.debounce(this.updateEmptyProperty));
      }
      this.updateEmptyProperty();
    },
    updateEmptyProperty: function updateEmptyProperty() {
      this.empty = !this.collection || this.collection.isEmpty();
    },
    updateAttributes: function updateAttributes() {
      this.addClass('empty', this.getBoolOption('empty'));
    }
  });
  var VisualSearchView = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'ui visual search',
    childView: VisualSearchTokenView,
    childViewContainer: '.token.box',
    childViewEventPrefix: 'token',
    template: Templates.UIKit['visual.search'],
    options: {
      collection: null,
      placeholder: 'Click to search',
      icon: 'search',
      visible: true
    },
    childEvents: {
      'fieldResultsView:result:selected': 'selectFieldResult',
      'tokenResultsView:result:selected': 'selectTokenResult',
      'fieldResultsView:results:added': 'newSearchResults',
      'tokenResultsView:results:added': 'newSearchResults',
      'tokenResultsView:result:text': 'setSearchResultText',
      'tokenResultsView:press:footer': 'tokenResultsFooterPress'
    },
    events: {
      'blur @ui.input': 'handleInputBlur',
      'keydown': 'handleKeydown',
      'keydown @ui.input': 'handleInputKeydown',
      'keyup @ui.input': 'handleInputKeyup',
      'mousedown .prompt': 'handleMousedown',
      'mousedown @ui.input': 'handleInputMousedown',
      'mousedown @ui.tokens': 'handleTokensMousedown',
      'mousedown @ui.clearResults': 'handleClearIconMousedown',
      'click @ui.clearResults': 'handleClearAll'
    },
    collectionEvents: {
      'remove': function remove(t) {
        this.triggerMethod('token:remove', t);
      }
    },
    ui: {
      input: '.token.input',
      tokens: '.token.box',
      clearResults: '.token.clear.icon',
      placeholder: '.placeholder'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.tokenResultsView = new VisualSearchResultsView();
      this.fieldResultsView = new VisualSearchResultsView();
    },
    tokenResultsFooterPress: function tokenResultsFooterPress() {
      var selected = this.selected;
      this.triggerMethod('search:press:footer', selected.detail, selected.text);
    },
    defineNewTokenObj: function defineNewTokenObj(selected, type) {
      var tokenObj = {},
        results = this.fieldResultsView,
        selectedText = selected || results.getSelectedResult();
      if (selectedText) {
        tokenObj.text = selectedText;
        if (type === 'date') {
          tokenObj.dateType = 'true';
        }
      } else {
        tokenObj.text = results["default"] || 'Text';
        tokenObj.value = this.ui.input.text();
      }
      return tokenObj;
    },
    generateNewToken: function generateNewToken(selected, type) {
      var token = new VisualSearchToken(this.defineNewTokenObj.apply(this, arguments)),
        tokenView = null;
      this.collection.push(token);
      tokenView = this.children.findByModel(token);
      if (!this.isFieldResultsEmpty() || selected) {
        token._newToken = true;
        this.hideFieldResultsView();
        tokenView.setCursorToStart();
      } else {
        this._tokenCreated(token);
      }
      this.ui.input.text('');
    },
    focusCursorOnInput: function focusCursorOnInput() {
      var input = this.ui.input.get(0);
      setCursorAt(input, input.textContent.length);
      this.ui.placeholder.hide();
    },
    handleClearAll: function handleClearAll() {
      var tokens = this.collection.models.slice(0),
        self = this;
      tokens.forEach(function (token) {
        self.collection.remove(token);
      });
      this.ui.input.blur();
    },
    handleTokensMousedown: function handleTokensMousedown(ev) {
      ev.originalEvent.ignoreFocus = true;
    },
    handleInputMousedown: function handleInputMousedown(ev) {
      ev.originalEvent.ignoreCursor = true;
    },
    handleClearIconMousedown: function handleClearIconMousedown(ev) {
      ev.stopPropagation();
    },
    handleMousedown: function handleMousedown(ev) {
      if (!ev.originalEvent.ignoreFocus) {
        if (!ev.originalEvent.ignoreCursor) {
          ev.preventDefault();
          this.focusCursorOnInput();
        }
        this.triggerMethod('search:field', this.ui.input.text());
      }
    },
    handleInputBlur: function handleInputBlur(ev) {
      this.hideFieldResultsView();
      this.showPlaceholder();
    },
    showPlaceholder: function showPlaceholder() {
      if (!(this.collection && this.collection.length) && !this.ui.input.text().length) {
        this.ui.placeholder.show();
      }
    },
    setSearchResultText: function setSearchResultText(v, result) {
      var text = result ? result.text : this.selected.detail;
      this.selected.setTextContent(text);
    },
    newSearchResults: function newSearchResults(v) {},
    selectFieldResult: function selectFieldResult(results, selected) {
      this.generateNewToken(selected.text, selected.model.get('type'));
    },
    selectTokenResult: function selectTokenResult(results, selected) {
      this.selected.detail = selected.text;
      this.selected.triggerMethod('complete');
    },
    handleInputKeydown: function handleInputKeydown(ev) {
      var tokens = this.children;
      this.ui.placeholder.hide();
      this._inputOldValue = this.ui.input.text();
      if (ev.keyCode === CODES.ENTER_KEY) {
        ev.preventDefault();
      } else if (ev.keyCode === CODES.BACKSPACE_KEY) {
        if (!this.ui.input.text().length && tokens.length) {
          tokens.findByIndex(tokens.length - 1).setFocus();
        }
      } else if (ev.keyCode === CODES.DOWNARROW_KEY && !this.isFieldResultsEmpty()) {
        ev.preventDefault();
        this.fieldResultsView.selectNextResult();
      } else if (ev.keyCode === CODES.UPARROW_KEY && !this.isFieldResultsEmpty()) {
        ev.preventDefault();
        this.fieldResultsView.selectPreviousResult();
      } else if (ev.keyCode === CODES.ESCAPE_KEY) {
        ev.preventDefault();
        this.ui.input.text('');
        this.ui.input.blur();
      }
    },
    handleInputKeyup: function handleInputKeyup(ev) {
      var textContent = this.ui.input.text();
      if (ev.keyCode === CODES.DOWNARROW_KEY || ev.keyCode === CODES.UPARROW_KEY && !this.isFieldResultsEmpty()) {
        ev.preventDefault();
      } else if (ev.keyCode === CODES.ENTER_KEY) {
        ev.preventDefault();
        this.generateNewToken();
      } else {
        if (this._inputOldValue != textContent) {
          this.triggerMethod('search:field', textContent);
        }
        this._inputOldValue = null;
      }
    },
    handleKeydown: function handleKeydown(ev) {
      var keyCode = ev.keyCode,
        currView = this.selected,
        index = null;
      if (!currView) {
        return;
      } else {
        index = this.collection.indexOf(currView.model);
      }
      if (keyCode === CODES.LEFTARROW_KEY) {
        if (currView.editing) {
          clearSelection();
          currView.setFocus();
        } else {
          --index;
          if (index > -1) {
            ev.preventDefault();
            clearSelection();
            this.children.findByModel(this.collection.at(index)).setCursorToEnd();
          }
        }
      } else if (keyCode === CODES.RIGHTARROW_KEY) {
        if (currView.editing) {
          clearSelection();
          ++index;
          if (index < this.collection.length) {
            this.children.findByModel(this.collection.at(index)).setFocus().triggerMethod('selected');
          } else if (index == this.collection.length) {
            this.ui.input.focus();
          }
        } else {
          ev.preventDefault();
          clearSelection();
          currView.setCursorToStart();
        }
      } else if (keyCode === CODES.DOWNARROW_KEY && !this.isTokenResultsEmpty()) {
        ev.preventDefault();
        this.tokenResultsView.selectNextResult();
      } else if (keyCode === CODES.UPARROW_KEY && !this.isTokenResultsEmpty()) {
        ev.preventDefault();
        this.tokenResultsView.selectPreviousResult();
      }
    },
    hideFieldResultsView: function hideFieldResultsView() {
      this.fieldResultsView.collection = null;
    },
    hideTokenResultsView: function hideTokenResultsView() {
      this.tokenResultsView.collection = null;
    },
    isFieldResultsEmpty: function isFieldResultsEmpty() {
      return !(this.fieldResultsView.collection && this.fieldResultsView.collection.length);
    },
    isTokenResultsEmpty: function isTokenResultsEmpty() {
      return !(this.tokenResultsView.collection && this.tokenResultsView.collection.length);
    },
    onRender: function onRender() {
      this.unbindEntityEvents(this.collection, this.getOption('collectionEvents'));
      this.bindEntityEvents(this.collection, this.getOption('collectionEvents'));
      this.showPlaceholder();
    },
    onTokenClose: function onTokenClose(v) {
      var self = this;
      this.selected = null;
      v.hide({
        animation: 'scale',
        onComplete: function onComplete() {
          self.collection.remove(v.model);
          self.focusCursorOnInput();
        }
      });
    },
    onTokenValueEdit: function onTokenValueEdit(v, value) {
      this.triggerMethod('search:value', value, v.text);
    },
    onTokenComplete: function onTokenComplete(v) {
      if (!this.isTokenResultsEmpty() && this.tokenResultsView.selected) {
        v.detail = this.tokenResultsView.getSelectedResult();
      }
      if (v.model._newToken) {
        this._tokenCreated(v.model);
        v.model._newToken = false;
      } else {
        this._tokenRevised(v.model);
      }
    },
    onTokenEditing: function onTokenEditing(v) {
      if (!v.selected) {
        this.selectToken(v);
      }
      v.editing = true;
      var self = this;
      _.defer(function () {
        self.triggerMethod('search:value', v.detail, v.text);
      });
    },
    onTokenNotEditing: function onTokenNotEditing(v) {
      v.editing = false;
      this.hideTokenResultsView();
    },
    onTokenDeselect: function onTokenDeselect(v) {
      this.selected = null;
      v.selected = false;
    },
    onTokenSelected: function onTokenSelected(v) {
      this.selectToken(v);
    },
    _tokenCreated: function _tokenCreated(token) {
      this.triggerMethod('token:add', token);
      clearSelection();
    },
    _tokenRevised: function _tokenRevised(token) {
      this.triggerMethod('token:revised', token);
      clearSelection();
    },
    selectToken: function selectToken(v) {
      this.selected = v;
      this.children.without(v).forEach(function (c) {
        c.selected = false;
        c.editing = false;
      });
      v.selected = true;
    },
    changeResultsPopupPosition: function changeResultsPopupPosition(results) {
      var el = this.selected ? this.selected.$el : this.ui.input,
        width = el.outerWidth();
      results.$el.css({
        left: el.position().left + width - 10,
        top: el.position().top + 1.5 * parseInt(el.css('font-size'))
      });
    },
    updateAttributes: function updateAttributes() {
      this.addClass('icon', this.getBoolOption('icon'));
    }
  });
  VisualSearchView.ResultsView = VisualSearchResultsView;
  module.exports = VisualSearchView;
});

